export default __webpack_public_path__ + "static/media/shimmering_nectar.400e4cb0.png";